

import photo2 from '../assets/images/photo2.jpg';
import photo3 from '../assets/images/photo3.jpg';
import photo4 from '../assets/images/photo4.jpg';
import photo5 from '../assets/images/photo5.jpg';
import photo6 from '../assets/images/photo6.jpg';
import cover from '../assets/images/cover.png';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/navbar';
import Footer from '../components/footer';


const Home = () => {
    const navigate = useNavigate();

    return (
        <div className="layout">
           <Navbar />
           
           
           
            <div className='rowBox'>
                <div className='imageBox'>
                   <img src={photo2} className='images'/>
                </div>
                <div className='textBox'>
                    <p>KWHour is an end-to-end EPC (Engineering, Procurement, 
                    and Construction) solutions provider specializing in renewable energy projects. The company delivers comprehensive services—from design and procurement to installation and commissioning—ensuring efficient, 
                    sustainable, and cost-effective energy solutions.</p>
                </div>
            </div>
            
            <div className='rowBox'>
                <div className='textBox'>
                    <h2>Engineering & Design</h2>
                    <p>We develop precision-engineered renewable energy systems tailored to site conditions and performance goals.
                      Our design approach ensures maximum efficiency, long-term reliability, and seamless project integration.</p>
                </div>
                <div className='imageBox'>
                  <img src={photo3} className='images'/>
                </div>
            </div>
                
            
            <div className='rowBox'>
                <div className='imageBox'>
                   <img src={photo4} className='images'/>
                </div>
                <div className='textBox'>
                    <h2>Construction & Installation</h2>
                    <p>Our skilled teams execute construction with safety, speed, and technical excellence at every stage.
                       From groundwork to final installation, we deliver clean, efficient, and dependable builds.</p>
                </div>
            </div>
            
             <div className='rowBox'>
                <div className='textBox'>
                    <h2>Commissioning</h2>
                    <p>We perform comprehensive system testing and validation to ensure every component operates at peak efficiency.
                       Our commissioning process certifies performance, compliance, and long-term operational stability.</p>
                </div>
                <div className='imageBox'>
                  <img src={photo5} className='images'/>
                </div>
            </div>
            
            <div className='rowBox'>
                <div className='imageBox'>
                   <img src={photo6} className='images'/>
                </div>
                <div className='textBox'>
                    <h2>Project Management</h2>
                    <p>Our project managers oversee every detail, ensuring flawless 
                        coordination across engineering, procurement, and construction.
                        We maintain tight control on timelines, 
                        quality, and budgets to deliver predictable and transparent outcomes.</p>
                </div>
            </div>
            
            <Footer />
        </div>
    )
}

export default Home;